// extracted by mini-css-extract-plugin
module.exports = {"uploadButton":"VideoUploadForm_uploadButton__j09t9","icon":"VideoUploadForm_icon__1LaDM","text":"VideoUploadForm_text__128UX"};